'use strict';

angular.module('far.news')
	.controller('NewsEditController', function ($log, $http, $rootScope, News, Discipline, Committee, NewsCategory, newsForm, showModalMessage, softdeleteable) {
		var vm = {
			progress: true,
			submitted: false,
            event: undefined,
			form: {},
			fields: newsForm,
			constructor: function (news, event) {
                if ( event ) {
                    $http.get(Routing.generate('api_event_get_event', {id: event}))
                        .then(function(response) {
                            vm.event = response.data;
                            vm.news( news );
                        })
                        .catch(function(response) {
                            $log.error(response);
                        });
                } else {
                    vm.news( news );
                }
			},
            news: function( news ) {
                if ( news ) {
                    vm.form = News.get(news, function() {
                        vm.disciplines();
                        vm.categories();
                        vm.committees();
                        
                        softdeleteable.setModel(News);

                        vm.progress = false;
                    });
                } else {
                    vm.form = News.new({
                        slides_files: []
                    });

                    if ( vm.event ) {
                        vm.form.disciplines = vm.event.disciplines;

                        vm.disciplines();
                        vm.categories();
                        vm.committees();
                    }

                    vm.progress = false;
                }

                vm.fields.$fields.slides_files.uploader.onSuccessItem = function (item, response) {
                    vm.form.slides_files.push(response);
                };
            },
			submit: function () {
                vm.form.slides_files = vm.form.slides_files.map(function(slide, index) {
                    slide.sort = index + 1;
                    return slide;
                });

                if ( vm.event ) {
                    vm.form.event = vm.event.id;
                }

                if (vm.form.youtube) {
                    var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
                    var match = vm.form.youtube.match(regExp);

                    if (match && match[2].length === 11) {
                        vm.form.youtube = 'https://www.youtube.com/embed/' + match[2];
                    }
                }

				vm.form.save()
					.then(function (response) {
						document.location.href=Routing.generate('news_view', {id: response.data.id});
					})
					.catch(function (response) {
						$log.error(response);
						showModalMessage('Не удалось сохранить изменения на сервере. Попробуйте повторить попытку через некоторое время.');
					});
			},
            disciplines: function () {
                var disciplineWatch = $rootScope.$watch(function() {
                    return Discipline.list.length;
                }, function(newVal) {
                    if (newVal > 0) {
                        Discipline.list.forEach(function(discipline_item) {
                            /* if ( vm.event ) {
                                discipline_item.disabled = true;
                            } */

                            if ( angular.isArray( vm.form.disciplines ) ) {
                                vm.form.disciplines.forEach(function(selectedDiscipline) {
                                    if (discipline_item.id == selectedDiscipline.id) {
                                        discipline_item.selected = true;
                                    }
                                });
                            }
                        });
                        disciplineWatch();
                    }
                });
            },
            committees: function () {
                var committeeWatch = $rootScope.$watch(function() {
                    return Committee.list.length;
                }, function(newVal) {
                    if (newVal > 0) {
                        Committee.list.forEach(function(committee_item) {
                            /* if ( vm.event ) {
                                committee_item.disabled = true;
                            } */

                            if ( angular.isArray( vm.form.committees ) ) {
                                vm.form.committees.forEach(function(selectedCommittee) {
                                    if (committee_item.id == selectedCommittee.id) {
                                        committee_item.selected = true;
                                    }
                                });
                            }
                        });
                        committeeWatch();
                    }
                });
            },
            categories: function () {
                var categoryWatch = $rootScope.$watch(function() {
                    return NewsCategory.list.length;
                }, function(newVal) {
                    if (newVal > 0) {
                        NewsCategory.list.forEach(function(category_item) {
                            /* if ( vm.event ) {
                                category_item.disabled = true;
                            } */

                            if ( angular.isArray( vm.form.categories ) ) {
                                vm.form.categories.forEach(function(selectedNewsCategory) {
                                    if (category_item.id == selectedNewsCategory.id) {
                                        category_item.selected = true;
                                    }
                                });
                            }
                        });

                        categoryWatch();
                    }
                });
            },
            delete: function() {
                vm.deleted = true;

                softdeleteable.delete(vm.form.id);
            },
            restore: function() {
                vm.deleted = false;

                softdeleteable.restore(vm.form.id);
            }
		};

		vm.fields.$fields.avatar.uploader.onSuccessItem = function (item, response) {
			vm.form.avatar = response;
		};

		return vm;
	});
